import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AdminUser } from "../../apis/adminApis";

interface AdminState {
  admins: AdminUser[];
  needRefresh: boolean;
}

const initialState: AdminState = {
  admins: [],
  needRefresh: true,
};

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    setAdmins: (state, action: PayloadAction<AdminUser[]>) => {
      state.admins = action.payload;
      state.needRefresh = false;
    },
    setAdminNeedRefresh: (state, action: PayloadAction<boolean>) => {
      state.needRefresh = action.payload;
    },
  },
});

export const { setAdmins, setAdminNeedRefresh } = adminSlice.actions;
export default adminSlice.reducer;
